var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classnames,on:{"click":_vm.checkBox}},[(_vm.is_checked)?_c('svg-icon',{staticClass:"pick-icon",attrs:{"name":_vm.icon_checked}}):_c('svg-icon',{staticClass:"pick-icon",attrs:{"name":_vm.icon}}),(_vm.text)?_c('p',{staticClass:"label-desc"},[_vm._v(_vm._s(_vm.text))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }